<template>
<Tooltip :message="tooltipMessage">
  <div
    @click="changeModalChatBotDetail(true)"
    class="chatbot-card"
    :class="{
      'medium'  : scale === 'is-medium',
      'small'   : scale === 'is-small',
      'noattend': uses  === 'noattend'
    }">
    <!-- モーダル用 -->
    <portal to="modal-detail" v-if="isModalChatBotDetail">
      <ModalChatBotDetails
        ref="detail"
        :chatbot="chatbot"
        :userChatBotBookMark="userChatBotBookMark"
        :users="users"
        :user="user"
        :sitemapRootList="sitemapRootList"
        :sitemapEmploymentList="sitemapEmploymentList"
        :isShowModal="isModalChatBotDetail"
        :uses="uses"
        :usersStatusAPI="usersStatusAPI"
        @cancel="changeModalChatBotDetail"
        @setIcon="setIcon"
        @changeBookMark="changeBookMark"
        @movePartsEdit="movePartsEdit"
        @updateChatBot="updateChatBot"
        @deleteChatBot="deleteChatBot"
        @createChatBotTags="createChatBotTags"
        @deleteChatBotTags="deleteChatBotTags"
        @clickRoboLock="clickRoboLock"
        :PCTRLLOG="CTRLLOG"
      />
    </portal>
    <portal to="modal-detail" v-if="isModalChatBotCreateDetail">
      <ModalChatBotCreateDetails
        ref="detail"
        :chatbot="chatbot"
        :storeCategory="storeCategory"
        :isShowModal="isModalChatBotCreateDetail"
        @cancel="changeModalChatBotDetail"
        @clickCreateChatBot="clickCreateChatBot"
      />
    </portal>
    <portal to="modal-detail" v-if="isModalChatBotContextMenu">
      <ModalChatBotContextMenu
        ref="detail"
        :chatbot="chatbot"
        :userChatBotBookMark="userChatBotBookMark"
        :users="users"
        :user="user"
        :sitemapRootList="sitemapRootList"
        :sitemapEmploymentList="sitemapEmploymentList"
        :isShowModal="isModalChatBotContextMenu"
        :uses="uses"
        @cancel="changeModalChatBotContextMenu"
        @setIcon="setIcon"
        @changeBookMark="changeBookMark"
        @movePartsEdit="movePartsEdit"
        @updateChatBot="updateChatBot"
        @deleteChatBot="deleteChatBot"
        @createChatBotTags="createChatBotTags"
        @deleteChatBotTags="deleteChatBotTags"
      />
    </portal>
    <!-- 中サイズのカード -->
    <template v-if="scale === 'is-medium'">
      <!-- タグリスト -->
      <div class="tag-group" v-if="uses != 'store'">
        <ChatBotTags
          :chatbot="chatbot"
          :sitemapRootList="sitemapRootList"
          :sitemapEmploymentList="sitemapEmploymentList"
          :isNew="false"
        />
      </div>
      <!-- 画像と詳細 -->
      <div class="main-box">
        <div class="icon-area">
          <div class="icon-wrapper">
            <img class="chatbot-icon" :src="getIconURL(chatbot)"/>
            <span class="minirobo-icon-base" v-if="(chatbot.chatbot_mini || []).length > 0">
              <img class="minirobo-icon" :src="getIconURL(chatbot.chatbot_mini[0])"/>
            </span>
            <span class="minirobo-num" v-if="(chatbot.chatbot_mini || []).length > 1">{{"+"+((chatbot.chatbot_mini || []).length - 1)}}</span>
          </div>
        </div>
        <div class="desc">
          <!-- ロボ名 -->
          <h2 class="chatbot-title">{{chatbot.name}}</h2>
          <p>24時間365日対応</p>
          <p>ホームページ設置</p>
          <p>採用ページ設置</p>
        </div>
      </div>
    </template>
    <!-- 小サイズのカード -->
    <template v-if="scale === 'is-small'">
      <!-- ロボ名 -->
      <h2 class="small-title">{{chatbot.name}}</h2>
      <!-- アイコン -->
      <img class="chatbot-icon-small" :src="getIconURL(chatbot)"/>
      <!-- タグリスト -->
      <div class="tag-group-small">
        <template v-if="isTags(chatbot.chatbot_tag)">
          <b-tag
            type="is-primary"
            size="is-small">
            {{chatbot.chatbot_tag[0].name}}
          </b-tag>
        </template>
        <template v-else>
          <b-tag size="is-small">
            タグ 設定なし
          </b-tag>
        </template>
      </div>
    </template>
  </div>
</Tooltip>
</template>

<script>
import Tooltip             from '@/components/atoms/tooltips/Tooltip'
import ChatBotTags         from '@/components2/Common/Screen/organisms/ChatBotTags'
import ModalChatBotDetails from '@/components2/Robo/modal/organisms/ModalChatBotDetails'
import ModalChatBotContextMenu from '@/components/ChatBot/organisms/ModalChatBotContextMenu'
import ModalChatBotCreateDetails from '@/components/ChatBot/organisms/ModalChatBotCreateDetails'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  name: 'ChatBotCard',
  componentName: 'ChatBotCard',
  components: {
    Tooltip,
    ChatBotTags,
    ModalChatBotDetails,
    ModalChatBotContextMenu,
    ModalChatBotCreateDetails
  },
  mixins: [
    controlLogMixin
  ],
  computed: {
    tooltipMessage () {
      switch (this.uses) {
        case 'bookmark':
          return 'クリックでロボの詳細を表示します。\nロボ名：' + this.chatbot.name
        case 'attend':
          return 'クリックでロボの詳細を表示します。\nロボ名：' + this.chatbot.name
        case 'attend':
          return 'クリックでロボの詳細を表示します。\nロボ名：' + this.chatbot.name + '\nこちらのロボは現在待機中です。'
        case 'store':
          return 'クリックでロボを雇用することができます。\nロボ名：' + this.chatbot.name
        default:
          return 'クリックでロボの詳細を表示します。\nロボ名：' + this.chatbot.name
      }
    }
  },
  props: {
    scale: {
      type: String,
      require: true
    },
    uses: {
      type: String,
      require: true
    },
    chatbot: {
      type: Object,
      require: true
    },
    storeCategory: {
      type: Array,
      require: false
    },
    userChatBotBookMark: {
      type: Array,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    sitemapRootList: {
      type: Array,
      required: true
    },
    sitemapEmploymentList: {
      type: Array,
      required: true
    },
    modalCloseFlg: {
      type: Boolean,
      required: false
    },
    usersStatusAPI: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      searchChatBotName: null,
      isModalChatBotDetail: false,
      isModalChatBotCreateDetail: false,
      isModalChatBotContextMenu: false,
    }
  },
  methods: {
    changeModalChatBotDetail (flg) {
      // 雇用前以外はモーダル開閉
      if (this.uses != 'store') {
        this.isModalChatBotDetail = flg
      } else {
        this.isModalChatBotCreateDetail = flg
      }
    },
    changeModalChatBotContextMenu (flg) {
      // 雇用前以外はモーダル開閉
      if (this.uses != 'store') {
        this.isModalChatBotContextMenu = flg
      } else {
        this.isModalChatBotCreateDetail = flg
      }
    },
    clickCreateChatBot (chatbot) {
      this.$emit('clickCreateChatBot', chatbot)
    },
    // icon 表示
    getIconURL (chatbot) {
      if (chatbot.icon_data) {
        return chatbot.icon_data
      } else {
        return require('@/assets/template/robot.png')
      }
    },
    // Tagが存在するか
    isTags (tags) {
      if (tags) {
        if (tags.length > 0) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    // emit定義
    setIcon (data) {
      // iconの更新
      this.$emit('setIcon', data)
    },
    changeBookMark (chatbot) {
      this.$emit('changeBookMark', chatbot)
    },
    cbUrlSetting (chatbot) {
      this.$emit('cbUrlSetting', chatbot)
    },
    movePartsEdit (chatbot) {
      this.$emit('movePartsEdit', chatbot)
    },
    updateChatBot (chatbot) {
      this.$emit('updateChatBot', chatbot)
    },
    deleteChatBot (chatbot) {
      this.$emit('deleteChatBot', chatbot)
    },
    createChatBotTags (e) {
      this.$emit('createChatBotTags', {
        tag: e,
        chatbot: this.chatbot
      })
    },
    deleteChatBotTags (e) {
      this.$emit('deleteChatBotTags', {
        tag: e,
        chatbot: this.chatbot
      })
    },
    clickRoboLock (chatbot) {
      this.$emit('clickRoboLock', chatbot)
    }
  },
  watch: {
    modalCloseFlg () {
      if (this.modalCloseFlg) {
        this.isModalChatBotDetail = false
        this.isModalChatBotCreateDetail = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.medium {
  width: 260px;
  transition: 0.2s;
}
.medium:hover {
  transform: scale(1.02);
}
.small {
  width: 100px;
  height: 100px;
  transition: 0.2s;
  .small-title {
    font-size: 12px;
    text-align: left;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 4px;
  }
  .chatbot-icon-small {
    height: 36px;
    width:  36px;
    margin: auto;
    border-radius: 50%;
    background: white;
    border: solid thin #ccc;
  }
  .tag-group-small {
    text-align: center;
    font-size: 12px;
    span {
      font-size: 11px;
    }
  }
}
.small:hover {
  transform: scale(1.05);
}
.chatbot-card {
  cursor: pointer;
  padding: 8px;
  margin: 8px;
  border: solid thin #ccc;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  .tag-group {
    width: 100%;
    display: flex;
    .-tag {
      margin: 4px;
    }
    span {
      font-size: 11px;
    }
  }
  .chatbot-title {
    font-size: 13px;
    font-weight: 600;
    text-align: left;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .main-box {
    margin-top: 8px;
    display: flex;
    width: 100%;
    .icon-area {
      margin: auto;
      width:  60px;
      height: 60px;
      .icon-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        .chatbot-icon {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
          background: white;
          border: solid thin #ccc;
        }
        .minirobo-icon-base {
          position: absolute;
          width: 50%;
          height: 50%;
          right: -12.5%;
          bottom: -12.5%;
          border-radius: 50%;
          background: white;
          border: solid thin #ccc;
          .minirobo-icon {
            object-fit: cover;
            border-radius: 50%;
            width: 100%;
            height: 100%;
            opacity: 0.5;
          }
        }
        .minirobo-num {
          position: absolute;
          font-size: 16px;
          font-weight: bold;
          bottom: 5%;
          right: -20%;
        }
      }
    }
    .desc {
      padding-left: 24px;
      width: calc(100% - 60px);
      margin: auto;
      p {
        width: 100%;
        font-size: 13px;
        text-align: left;
      }
    }
  }
}
.noattend {
  background: #DDD;
}
</style>


// WEBPACK FOOTER //
// src/views/DashBoard/ChatBot/ChatBotCard.vue